module.exports = "<div id=\"map\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/snail-trail/views/snail-trail-map.component.html
// module id = 63
// module chunks = 0